import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NbDialogRef, NbToastrService} from "@nebular/theme";
import {ImageCropperComponent} from "ngx-image-cropper";

@Component({
    selector: 'bst-crop-dialog',
    templateUrl: './crop-dialog.component.html',
    styleUrls: ['./crop-dialog.component.scss'],
    standalone: false
})
export class CropDialogComponent implements OnInit {

  @ViewChild('cropper', {static: true}) cropper: ImageCropperComponent;

  @Input() public file: File;
  @Input() public ratio: number = 1;
  @Input() public round: boolean = true;
  @Input() public background: string = '#f7f9fc';

  loading: boolean;

  constructor(protected ref: NbDialogRef<CropDialogComponent>,
              protected toast: NbToastrService) { }

  ngOnInit(): void {
    this.loading = true;
  }

  cancel() {
    this.ref.close(null);
  }

  submit() {
    this.ref.close(this.cropper);
  }

  loadImageFailed() {
    this.toast.danger('Image Load Failed');
  }
}
